import { render, staticRenderFns } from "./HelpFileFormat.vue?vue&type=template&id=49a1e62f"
import script from "./HelpFileFormat.vue?vue&type=script&lang=js"
export * from "./HelpFileFormat.vue?vue&type=script&lang=js"
import style0 from "./HelpFileFormat.vue?vue&type=style&index=0&id=49a1e62f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports